import React from 'react'
import { sheetAtom } from 'atoms/atoms'
import { useAtom, useAtomValue, useSetAtom } from 'jotai'
import { useTranslation } from 'react-i18next'
import { useMatch } from 'react-router-dom'
import { Sheet } from '@node-space/ui-components'
import { PathNames } from 'constants/General'
import { SheetName, SheetState } from 'types/types'
import {
  contactAtom,
  contactInstrumentAtom,
  editingContactAtom,
  editingContactInstrumentAtom,
} from '../atoms/contactAtoms'
import { ContactForm } from '../ContactForm'
import { ContactInstrumentForm } from '../ContactInstrumentForm'

export const ContactsSheets = () => {
  const { t } = useTranslation()
  const match = useMatch(PathNames.CRYPTO_CONTACTS)
  const setContactInstrument = useSetAtom(contactInstrumentAtom)
  const setContact = useSetAtom(contactAtom)
  const isEditingContact = useAtomValue(editingContactAtom)
  const isEditingContactInstrument = useAtomValue(editingContactInstrumentAtom)
  const [sheet, setSheet] = useAtom(sheetAtom)

  const isContactSheetOpen = sheet?.[SheetName.CONTACT] === SheetState.OPEN
  const isInstrumentSheetOpen = sheet?.[SheetName.INSTRUMENT] === SheetState.OPEN

  const handleOnClickClose = (sheetName: SheetName) => {
    if (match) {
      setContact(null)
    } else {
      // contact instrument only gets set on the contact instrument page
      setContactInstrument(null)
    }
    setSheet({
      [sheetName]: SheetState.CLOSED,
    })
  }

  return (
    <>
      <Sheet
        isOpen={isContactSheetOpen}
        header={
          isEditingContact ? t('contacts.updateCryptoContact') : t('contacts.addCryptoContact')
        }
        setIsOpen={() => null}
        onClose={() => handleOnClickClose(SheetName.CONTACT)}
      >
        <ContactForm />
      </Sheet>

      <Sheet
        isOpen={isInstrumentSheetOpen}
        header={
          isEditingContactInstrument
            ? t('contacts.updateCryptoAccount')
            : t('contacts.addCryptoAccount')
        }
        setIsOpen={() => null}
        onClose={() => handleOnClickClose(SheetName.INSTRUMENT)}
      >
        <ContactInstrumentForm />
      </Sheet>
    </>
  )
}
